import { createName } from 'store/utils';

import { FEATURE_NAME } from './consts';

const getName = createName(FEATURE_NAME);

export const UPDATE_MEDICAL_HISTORY = getName('UPDATE_MEDICAL_HISTORY');
export const RESET_MEDICAL_HISTORY = getName('RESET_MEDICAL_HISTORY');
export const UPDATE_MEDICATIONS = getName('UPDATE_MEDICATIONS');
export const UPDATE_MEDICATION = getName('UPDATE_MEDICATION');
export const DELETE_MEDICATION = getName('DELETE_MEDICATION');
export const RESET_MEDICATIONS = getName('RESET_MEDICATIONS');

export const FETCH_MEDICAL_HISTORY = getName('FETCH_MEDICAL_HISTORY');
export const FETCH_COLLECT_MEDICAL_HISTORY = getName('FETCH_COLLECT_MEDICAL_HISTORY');
export const SAVE_MEDICAL_HISTORY = getName('SAVE_MEDICAL_HISTORY');
export const UPLOAD_MEDIA_DATA = getName('UPLOAD_MEDIA_DATA');
export const FETCH_SEARCHABLE_MEDIA = getName('FETCH_SEARCHABLE_MEDIA');
export const DELETE_SEARCHABLE_MEDIA = getName('DELETE_SEARCHABLE_MEDIA');
export const FETCH_DRUGS = getName('FETCH_DRUGS');
export const SAVE_DRUG = getName('SAVE_DRUG');
export const CREATE_MEDICATION = getName('CREATE_MEDICATION');
export const SAVE_MEDICATION = getName('SAVE_MEDICATION');
export const REMOVE_MEDICATION = getName('REMOVE_MEDICATION');
